var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState } from 'react';
import { DateRangePicker } from 'rsuite';
import { stopPropagation } from '../general/Utils';
import { setFilter, filterListener } from './Utils';
import FilterToggle from './FilterToggle';
function FilterDatePicker(props) {
    var attribute = props.attribute, componentId = props.componentId, rename = props.rename, zone = props.zone, setZone = props.setZone;
    var _a = useState(), value = _a[0], setValue = _a[1];
    var _b = useState(false), disabled = _b[0], setDisabled = _b[1];
    var _c = useState(false), exists = _c[0], setExists = _c[1];
    var _d = useState(false), negate = _d[0], setNegate = _d[1];
    filterListener({
        attribute: attribute,
        componentId: componentId,
        operators: ['gte', 'lt'],
        zone: zone,
        setValue: setValue,
        setExists: setExists,
        setNegate: setNegate,
        setDisabled: setDisabled,
        emptyValue: null,
        zoneToValue: function (filterValue, exisitingValue) {
            if (exisitingValue === null)
                return filterValue; // first iteration
            return [
                new Date(exisitingValue),
                new Date(filterValue)
            ]; // second iteration
        }
    }, [zone]);
    var onFilter = function (input) {
        var from = input !== null ? new Date(input[0]) : null;
        var to = input !== null ? new Date(input[1]) : null;
        if (from !== null)
            from.setHours(0, 0, 0, 0);
        if (to !== null)
            to.setHours(23, 59, 59, 999);
        setValue(input);
        setFilter({
            operator: 'gte',
            value: from,
            negate: negate,
            attribute: attribute,
            componentId: componentId,
            zone: zone,
            valueExists: from !== null
        });
        setFilter({
            operator: 'lt',
            value: to,
            negate: negate,
            attribute: attribute,
            componentId: componentId,
            zone: zone,
            valueExists: to !== null
        });
        setZone(__assign({}, zone));
    };
    var onExists = function (ex) {
        setExists(!ex);
        setValue(null);
        setFilter({
            operator: 'exists',
            negate: negate,
            exists: !ex,
            attribute: attribute,
            componentId: componentId,
            zone: zone
        });
        setZone(__assign({}, zone));
    };
    var onNegate = function (ng) {
        var from = value !== null ? new Date(value[0]) : null;
        var to = value !== null ? new Date(value[1]) : null;
        if (from !== null)
            from.setHours(0, 0, 0, 0);
        if (to !== null)
            to.setHours(23, 59, 59, 999);
        setNegate(!ng);
        setFilter({
            operator: (exists) ? 'exists' : 'gte',
            value: from,
            negate: !ng,
            exists: exists,
            attribute: attribute,
            componentId: componentId,
            zone: zone,
            valueExists: from !== null
        });
        setFilter({
            operator: (exists) ? 'exists' : 'lt',
            value: to,
            negate: !ng,
            exists: exists,
            attribute: attribute,
            componentId: componentId,
            zone: zone,
            valueExists: to !== null
        });
        setZone(__assign({}, zone));
    };
    return (_jsxs("div", __assign({ className: "tol-date-filter", onClick: stopPropagation }, { children: [_jsx(DateRangePicker, { block: true, 
                // @ts-ignore
                onChange: onFilter, value: value, placeholder: rename, format: "dd/MM/yyyy", disabled: disabled, preventOverflow: true }), _jsx(FilterToggle, { negate: negate, onNegate: onNegate, exists: exists, onExists: onExists, disabled: disabled })] })));
}
export default FilterDatePicker;
